import React from "react";
import "./CompaniesTableSkeleton.scss";

/**
 * Companies Table Skeleton Loader
 * Beautiful skeleton with smooth animations matching the companies table structure
 *
 * @param {number} rows - Number of skeleton rows to display (default: 50)
 */
const CompaniesTableSkeleton = ({ rows = 50 }) => {
  return (
    <>
      {[...Array(rows)].map((_, rowIndex) => (
        <tr
          key={rowIndex}
          className="company-row company-table-skeleton"
        >
          {/* Company Name Column */}
          <td className="company-name">
            <span className="skeleton-text" />
          </td>

          {/* Users Count Column */}
          <td className="user-count">
            <span className="user-count-badge skeleton-badge" />
          </td>
        </tr>
      ))}
    </>
  );
};

export default CompaniesTableSkeleton;

